import { CSSProperties, ReactNode } from "react";
import Flex from "common/Boxes/Flex";
import styled from "styled-components";

interface SquareSwitchProps {
  style?: CSSProperties;
  items: SwitchItem[];
  selectedKey: string;
  onChange: (selectedKey: string) => void;
}

const SquareSwitch = ({
  style,
  items,
  selectedKey,
  onChange,
}: SquareSwitchProps) => {
  return (
    <Background style={style}>
      {items.map((item) => (
        <IconBg
          key={item.key}
          $selected={item.key === selectedKey}
          onClick={() => onChange(item.key)}
        >
          <IconWrapper>{item.label}</IconWrapper>
        </IconBg>
      ))}
    </Background>
  );
};

export default SquareSwitch;

interface SwitchItem {
  label: ReactNode;
  key: string;
}

const Background = styled(Flex)`
  border-radius: 6px;
  padding: 4px;
  background: ${(p) => p.theme.colors.lightBlue};
  cursor: pointer;
`;
const IconBg = styled.div<{ $selected?: boolean }>`
  border-radius: 6px;
  padding: 5px 7px;
  fill: ${(p) =>
    p.$selected ? p.theme.colors.layoutBgColor : p.theme.colors.primaryBlue};
  color: ${(p) =>
    p.$selected ? p.theme.colors.layoutBgColor : p.theme.colors.primaryBlue};
  background: ${(p) =>
    p.$selected ? p.theme.colors.primaryBlue : "transparent"};
  transition: background-color 0.25s linear;
`;
const IconWrapper = styled(Flex)`
  height: 16px;
`;
